import React, { useState } from "react";
//outsource
import { Row, Col, Divider, Empty, Spin } from "antd";
import CardStaff from "./component/card_staff";
import lodash from "lodash";
//components

const IncomeStaffBoard = (props) => {
  // -------------------------- VAR --------------------------
  const {
    data,
    edit,
    removeRow,
    handleAdd,
    handleChange,
    handleDeleteIncome,
    loading,
  } = props;
  // -------------------------- STATE --------------------------
  const sumTotal = calculateSum(data);
  const maxIncome = renderMaxIncome(data);
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderListIncomes = () => {
    if (data === null) {
      return <Spin />;
    } else if (data?.length === 0) {
      return <Empty />;
    }
    // sorted by total
    const sortedData = data
      ?.slice()
      .sort(
        (a, b) =>
          lodash.sumBy(b?.income, (income) => income?.value) -
          lodash.sumBy(a?.income, (income) => income?.value)
      );
      
    return (
      <Row style={{ width: "100%" }}>
        {sortedData?.map((item, index) => {
          return (
            <Col style={{ margin: "10px 0px" }} key={index} span={24}>
              <CardStaff
                edit={edit}
                data={item}
                order={index}
                maxIncome={maxIncome}
                // removeRow={removeRow}
                handleAdd={handleAdd}
                handleChange={handleChange}
                handleDeleteIncome={handleDeleteIncome}
                // loading = {loading}
              />
            </Col>
          );
        })}
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row className="section-detail-income">
      <Col xl={24} lg={24} md={24} xs={24}>
        <strong>Income by staff detail:</strong>
      </Col>
      <Divider />
      <Col align="center" xl={24} lg={24} md={24} xs={24}>
        {renderListIncomes()}
      </Col>
      <Divider />
      <Col align="right" xl={22} lg={22} md={22} xs={22}>
        <strong className="text-total">Total</strong>
      </Col>
      <Col align="right" xl={2} lg={2} md={2} xs={2}>
        <strong className="text-total">$ {sumTotal}</strong>
      </Col>
    </Row>
  );
};

export default IncomeStaffBoard;

const calculateSum = (data) => {
  let sum = [];
  data?.forEach((item) => {
    let income = item?.income;
    sum = [...sum, ...income];
  });

  const total = lodash.sumBy(sum, (r) => r?.value);
  return total;
};

const renderMaxIncome = (data) => {
  const totals = data?.map((item) => {
    const income = item?.income;
    const total = lodash.sumBy(income, (r) => r?.value) || 0;
    return total;
  });

  const maxValue = lodash.max(totals);
  return maxValue;
};
